export const palette = {
  black: '#1d1d1d',
  smokyBlack: '#121212',
  gray: '#ccc',
  grey: '#68706D',
  white: '#FFFFFF',
  offWhite: '#e6e6e6',
  red: 'red',
  orange: '#FF7222',
  orangeDarker: '#EB9918',
  lightGrey: '#DDDAD2',
  lighterGrey: '#F1F5F9',
  angry: '#dd3333',
  HighSlateBlue: '#000F3C',
  MediumSlateBlue: '#A694CB',
  LowSlateBlue: '#22215B',
  darkBlack: '#000000',
  lightGreen: '#4DCEAA',
  grainBoro: '#D9D9D9',
  cream: '#F6F2E9',
  green: '#38443F',
  creamWithOpacity: {
    fifty: 'rgba(253, 248, 237, .5)'
  },
  blackWithOpacity: {
    twenty: 'rgba(18, 18, 18, .2)'
  },
  maroon: '#7B043D',
  timberwolf: '#DDDAD2',
  pink: '#FF3ED4',
  blue: '#5BC4FF',
  purple: '#480D93'
}
